import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import PageTitle from '../../Utils/smsTitle';
import { SubHeader } from '../../../Containers/SubHeader';

const useStyles = makeStyles(() => ({
  root: { margin: 22, padding: 20 },
  placeholder: {
    padding: 40,
    textAlign: 'center',
    color: '#999',
    border: '2px dashed #e0e0e0',
    borderRadius: 8,
    minHeight: 300,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: { fontSize: '1.25rem', fontWeight: 600, marginBottom: 8, color: '#333' },
  desc: { fontSize: '0.9rem', color: '#666' },
}));

const RescheduleSurgeryDialog = () => {
  const classes = useStyles();
  return (
    <div>
      <PageTitle title="Reschedule Surgery" />
      <SubHeader title="Surgery" subTitle="Reschedule Surgery" />
      <Paper className={classes.root} elevation={1}>
        <div className={classes.placeholder}>
          <Typography className={classes.title}>Reschedule Surgery</Typography>
          <Typography className={classes.desc}>Dialog for rescheduling a surgery with reason and new date</Typography>
        </div>
      </Paper>
    </div>
  );
};

export default RescheduleSurgeryDialog;
